/* eslint-disable no-magic-numbers */

import { NonFinancialDriverTreeNode } from '../../types';

export const generateMonthlyDateLabels = (startDate: Date, endDate: Date) => {
  const startMonth = startDate.getMonth() + 1;
  const startYear = startDate.getFullYear();
  const endMonth = endDate.getMonth() + 1;
  const endYear = endDate.getFullYear();

  const dates = [];
  let month = startMonth;
  let year = startYear;

  for (year; year < endYear; year++) {
    for (month; month <= 12; month++) {
      dates.push(`${year}-${month < 10 ? '0' : ''}${month}`);
    }
    month = 1;
  }

  for (month = 1; month <= endMonth; month++) {
    dates.push(`${endYear}-${month < 10 ? '0' : ''}${month}`);
  }

  return dates;
};

/**
 * Formats a driver value for display in the grid cell.
 */
export const formatDriverValue = (value: number | null | undefined, decimalDisplay: number): string => {
  if (value === null || value === undefined) {
    return '-';
  }
  return value.toFixed(decimalDisplay);
};

/**
 * Recursively filters a tree of driver nodes by name (case-insensitive).
 *
 * - Matching groups are retained with all of their descendants.
 * - Non-matching groups are retained if any of their children match, with only the matching branches included.
 * - Leaf nodes (drivers) are retained only if their name matches.
 *
 * @param tree - The tree nodes to filter.
 * @param search - The lowercase search string to match against node names.
 */
export const filterTreeByName = (tree: NonFinancialDriverTreeNode[], search: string): NonFinancialDriverTreeNode[] => {
  return tree.reduce<NonFinancialDriverTreeNode[]>((acc, node) => {
    if (node.isGroup) {
      if (node.name.toLowerCase().includes(search)) {
        acc.push({ ...node, children: node.children });
      } else {
        const filteredChildren = filterTreeByName(node.children, search);
        if (filteredChildren.length > 0) {
          acc.push({ ...node, children: filteredChildren });
        }
      }
    } else if (node.name.toLowerCase().includes(search)) {
      acc.push(node);
    }
    return acc;
  }, []);
};
